import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { UniversalSearch } from "@/design-system";
import { useOffline } from "@/offline/OfflineProvider";

function SyncStatus() {
  const o = useOffline();
  if (!o) return null;
  const { online, syncing, counts } = o;
  const label = !online ? "Offline" : syncing ? "Syncing…" : counts.pending ? "Waiting to sync" : "Synced";
  return (
    <Link to="/app/sync" data-testid="sync-status" className="text-xs border px-2 py-1 rounded">
      {label}
      {counts.pending > 0 && ` (${counts.pending})`}
      {counts.attention > 0 && <span className="text-red-600" data-testid="sync-attention"> · {counts.attention} need attention</span>}
    </Link>
  );
}

export function Topbar({ testid = "app-topbar" }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [searchOpen, setSearchOpen] = useState(false);

  const onLogout = async () => {
    await logout();
    toast.success("Signed out.");
    navigate("/login", { replace: true });
  };

  return (
    <header
      data-testid={testid}
      className="border-b border-[var(--phx-slate-200)] bg-white"
    >
      <div className="px-6 py-3 flex items-center justify-between gap-4">
        <button
          data-testid={`${testid}-search-trigger`}
          onClick={() => setSearchOpen(true)}
          className="h-9 w-72 border border-[var(--phx-slate-300)] rounded-[var(--phx-radius-md)] text-left text-sm text-[var(--phx-slate-500)] px-3 hover:bg-[var(--phx-slate-50)]"
        >
          Search everything…
        </button>
        <div className="flex items-center gap-3">
          <SyncStatus />
          <span
            data-testid={`${testid}-user`}
            className="text-xs font-mono text-[var(--phx-slate-700)]"
          >
            {user?.email || user?.phone} · {user?.role}
          </span>
          <button
            data-testid={`${testid}-logout`}
            onClick={onLogout}
            className="h-9 px-4 border border-[var(--phx-slate-300)] text-sm font-medium rounded-[var(--phx-radius-md)] hover:bg-[var(--phx-slate-50)]"
          >
            Sign out
          </button>
        </div>
      </div>
      <UniversalSearch open={searchOpen} onOpenChange={setSearchOpen} providers={[]} />
    </header>
  );
}
